// removed by extract-text-webpack-plugin
module.exports = {"nf-loadingTable":"nf-loadingTable"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/LoadingTable.scss
// module id = 2742
// module chunks = 1